const communities = [
  { name: "Mandan", zip: "58554" },
  { name: "Lincoln", zip: "58504" },
  { name: "Wilton", zip: "58579" },
  { name: "Steele", zip: "58482" },
  { name: "Washburn", zip: "58577" },
  { name: "Hazen", zip: "58545" },
  { name: "New Salem", zip: "58563" },
  { name: "Flasher", zip: "58535" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Bismarck and All of Burleigh County
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Fast Passport Center serves all Bismarck residents and surrounding Burleigh County communities. As the state capital of North Dakota, Bismarck is home to state employees, government contractors, and energy industry professionals who need reliable, fast passport services. Our courier network covers the entire south-central North Dakota region — including Mandan across the Missouri River and communities west along I-94.
            </p>
            <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6">
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">Nearest Regional Passport Agency</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                The Denver Passport Agency (1961 Stout St) is approximately <strong className="text-[#1A365D]">650+ miles</strong> south of Bismarck, and the Chicago agency is 700+ miles east. Both require advance appointments and are for genuine emergencies only. Fast Passport Center eliminates that lengthy journey entirely.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-md px-3 py-2">
                <i className="ri-map-pin-line text-[#F6C344]"></i>
                <span className="text-sm text-[#1A365D] font-medium">Bismarck, ND 58501</span>
              </div>
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-md px-3 py-2">
                <i className="ri-map-pin-line text-[#F6C344]"></i>
                <span className="text-sm text-[#1A365D] font-medium">Mandan, ND 58554</span>
              </div>
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-md px-3 py-2">
                <i className="ri-map-pin-line text-[#F6C344]"></i>
                <span className="text-sm text-[#1A365D] font-medium">Lincoln, ND 58504</span>
              </div>
            </div>
          </div>
          <div>
            <h3 className="font-bold text-[#1A365D] text-base mb-4">Communities We Serve</h3>
            <div className="grid grid-cols-2 gap-3">
              {communities.map((c, i) => (
                <div key={i} className="bg-white border border-gray-200 rounded-md px-4 py-3 flex items-center justify-between">
                  <span className="text-sm font-medium text-[#1A365D]">{c.name}</span>
                  <span className="text-xs text-gray-400">{c.zip}</span>
                </div>
              ))}
            </div>
            <div className="mt-6 bg-[#1A365D] rounded-lg p-5">
              <h4 className="font-bold text-white text-sm mb-2">Bismarck Municipal Airport (BIS)</h4>
              <p className="text-white/60 text-sm leading-relaxed">
                Bismarck Airport connects the state capital to major hubs including Minneapolis, Denver, and Chicago. Whether you&apos;re a state official, energy worker, or family traveler, Fast Passport Center ensures your passport is ready before departure day.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}